import { AppAssessmentProgress } from "@/schema/AssessmentProgress";
import HistoryTable from "@/src/console/(auth)/companies/[id]/_components/HistoryCard/HistoryTable";
import { useTranslation } from "react-i18next";

interface AssessmentProgressProps {
  data: AppAssessmentProgress[];
}

function AssessmentHistory({ data }: AssessmentProgressProps) {
  const { t } = useTranslation();
  return (
    <div className="my-card">
      <div className="px-6 py-5 text-lg font-medium text-cool-gray-900">
        {t("assessment-history")}
      </div>
      <HistoryTable data={data} />
    </div>
  );
}

export default AssessmentHistory;
